import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang, IMAGES } from "../i18n";
import { SectionLabel } from "./Motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";

export const Testimonials = () => {
  const { t } = useLang();
  const tt = t.testimonials;
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const n = tt.items.length;

  const go = (d) => {
    setDir(d);
    setI((prev) => (prev + d + n) % n);
  };

  const item = tt.items[i];

  return (
    <section id="stories" data-testid="testimonials-section" className="relative py-20 md:py-40 border-t border-[var(--border)] overflow-hidden">
      <div className="absolute -top-10 right-1/4 w-[480px] h-[480px] rounded-full bg-[var(--wine)]/20 blur-[160px] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <SectionLabel>{tt.label}</SectionLabel>
            <h2 className="font-cormorant font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[var(--text-primary)]">
              {tt.title}
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" className="w-12 h-12 rounded-full border border-[var(--border)] flex items-center justify-center text-[var(--text-primary)] hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <button onClick={() => go(1)} data-testid="testimonial-next" className="w-12 h-12 rounded-full border border-[var(--border)] flex items-center justify-center text-[var(--text-primary)] hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors">
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-center min-h-[420px]">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.div
              key={i}
              custom={dir}
              initial={{ opacity: 0, x: dir * 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -dir * 40 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="contents"
            >
              <div className="lg:col-span-7 order-2 lg:order-1" data-testid="testimonial-content">
                <Quote className="w-12 h-12 text-[var(--gold)]/40 mb-6" />
                <p className="font-cormorant italic font-light text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-[var(--text-primary)]">
                  {item.q}
                </p>
                <div className="mt-8">
                  <div className="font-outfit font-medium text-[var(--text-primary)]">{item.n}</div>
                  <div className="overline text-[10px] text-[var(--gold)] mt-1">{item.r}</div>
                </div>
                <div className="flex gap-2 mt-8">
                  {tt.items.map((_, idx) => (
                    <span key={idx} className={`h-1 rounded-full transition-all duration-400 ${idx === i ? "w-8 bg-[var(--gold)]" : "w-3 bg-[var(--border)]"}`} />
                  ))}
                </div>
              </div>

              <div className="lg:col-span-5 order-1 lg:order-2">
                <div className="relative rounded-[2rem] overflow-hidden border border-[var(--border)] aspect-[4/5]">
                  <img src={IMAGES[item.img]} alt={item.n} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)]/70 to-transparent" />
                  <span className="absolute top-6 left-6 w-6 h-6 border-t border-l border-[var(--gold)]/60" />
                  <span className="absolute bottom-6 right-6 w-6 h-6 border-b border-r border-[var(--gold)]/60" />
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
